/* wsshub */
/*--------------------------------------------------------------------------------*/
import { cfg } from '../../config';
import { toast } from '../../mod/dialog';
import { timeToStr, thaiDate } from '../../lib/dateTime';
import { http } from '../api';
/*--------------------------------------------------------------------------------*/
export const newTask = (worker: new () => Worker) => {
    if (!window.Worker) return;
    cfg.hub.TASK = new worker();
    cfg.hub.TASK.postMessage({
        head: 'INIT',
        data: {
            url: cfg.hub.WSS,
            app: cfg.app.NAME,
            uid: cfg.app.CODE,
            ver: cfg.app.VERSION,
        }
    });
    cfg.hub.TASK.addEventListener('message', (e) => {
        const { head, data } = e.data;
        if (head == 'ACCEPT') {
            rspAccept(data);
            pkgVerify();
        }
        if (head == 'DISCON') rspDiscon();
        if (head == 'KEYEXP') rspKeyExp();
        if (head == 'LATEST') rspLatest(data);
        if (head == 'BRDMSG') rspBrdMsg(data);
        if (head == 'VERIFY' && data != '200 OK') {
            console.log(head, data);
        }
    });
};
/*--------------------------------------------------------------------------------*/
export const checkUpdate = (min: number = 10) => {
    return setInterval(() => {
        cfg.hub.TASK?.postMessage({
            head: 'LATEST',
            data: {
                app: cfg.app.NAME,
                uid: cfg.app.CODE,
            }
        });
    }, 1000 * 60 * min); // defult 10 min
};
/*--------------------------------------------------------------------------------*/
const rspBrdMsg = (brd: BrdPack) => {
    const isTarget = brd.to == cfg.hub.UUID || brd.to == '@all';
    if (brd.cmd == "LOGS") console.log(brd.msg);
    if (brd.cmd == "TIME") setTime(brd.msg as { unix: number; });
    if (brd.cmd == 'RESULT' && brd.to == cfg.hub.UUID) {
        console.log(brd.cmd, 'From:', brd.from);
        console.log(brd.msg);
    }
    if (brd.cmd == 'CONRST' && isTarget) {
        sessionStorage.clear();
        window.location.reload();
    }
    if (brd.cmd == 'LOGOUT' && isTarget) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    }
    if (brd.cmd == 'NOTIFY' && isTarget) {
        brdNotify(brd.msg as NotifyPack);
    }
    if (!brd.cmd) console.log(brd.msg);
};
/*--------------------------------------------------------------------------------*/
const updateTimeUI = (isOffline: boolean, timeStr?: string, dateStr?: string) => {
    const boxTime = document.querySelector<HTMLElement>('#topbar #box-time');
    if (!boxTime) return;
    boxTime.classList.toggle('offline', isOffline);
    const svTime = boxTime.querySelector<HTMLElement>('#sv-time');
    const svDate = boxTime.querySelector<HTMLElement>('#sv-date');
    if (svTime) svTime.innerText = isOffline ? 'server' : (timeStr || '');
    if (svDate) svDate.innerText = isOffline ? 'OFFLINE' : (dateStr || '');
};
const rspAccept = (data: { uuid: string; }) => {
    cfg.hub.UUID = data?.uuid || '';
    console.log('hub-uuid:', cfg.hub.UUID);
    updateTimeUI(false);
    toast('เชื่อมต่อ Server สำเร็จ.!', { type: 'success' });
};
const rspDiscon = () => {
    updateTimeUI(true);
    toast('ขาดการเชื่อมต่อ Server.!', { type: 'failure' });
};
const setTime = (data: { unix: number; }) => {
    if (typeof data.unix !== 'number') return;
    cfg.UNIX_TIME = data.unix;
    const [date, time] = timeToStr(cfg.UNIX_TIME).split(' ');
    updateTimeUI(false, time, thaiDate(date, 11));
};
/*--------------------------------------------------------------------------------*/
const rspKeyExp = async () => {
    try {
        await http.getRefreshToken();
        pkgVerify();
    } catch (err) {
        console.error(err);
    }
};
const pkgVerify = () => {
    const token = localStorage.getItem(cfg.cookie.TOKEN);
    if (token) cfg.hub.TASK?.postMessage({
        head: 'VERIFY',
        data: token,
    });
};
/*--------------------------------------------------------------------------------*/
const rspLatest = (data: LatestPack) => {
    if (cfg.app.CODE == data.uuid && cfg.app.NAME == data.name) {
        const path = window.location.pathname;
        if (path != '/changelog' && cfg.app.RELEASE != data.release) {
            window.location.replace('/changelog');
        }
    }
};
/*--------------------------------------------------------------------------------*/
const brdNotify = (data: NotifyPack) => {
    const title = data.title ? data.title : 'Hub Notify';
    const icon = data.icon ? data.icon
        : 'https://cdn.jsdelivr.net/npm/slimsdk/dist/assets/icon/icon-06.png';
    const body = data.body ? data.body : '';
    if (!body) return;
    Notification.requestPermission().then(res => {
        if (res == 'granted') {
            new Notification(title, { body: body, icon: icon });
        }
    }).catch(err => console.error(err));
};
/*--------------------------------------------------------------------------------*/
export type BrdPack = {
    from: string;
    to: string;
    cmd: string;
    msg: unknown;
};
export type LatestPack = {
    uuid: string;
    name: string;
    version: string;
    release: string;
};
export type NotifyPack = {
    title?: string;
    icon?: string;
    body: string;
};